/* eslint-disable no-unused-vars */
import React, { useState } from "react";

import Iframe from "react-iframe";
import { Box, Flex } from "rebass";

const DashboardDataStudio = (props) => {
  const { width, height } = props;
  const [myWidth, setMyWidth] = useState(width);
  return (
    <Flex
      width={[1]}
      flexDirection={"column"}
      style={{ height: "120vh", overflowY: "hidden" }}
      pt={[2]}
    >
      <Iframe
        width={myWidth}
        height={height}
        src="https://datastudio.google.com/embed/reporting/1kzqu0hfiIJSIt36ocMEgeL23pGom3Dhl/page/ovOOB"
        frameborder="0"
        style={{ borderWidth: 0 }}
        allowfullscreen
      />
    </Flex>
  );
};

export default DashboardDataStudio;
